<template>
  <footer class="footer">
    <div class="footer-inner">
      <!-- 메인 영역 -->
      <div class="footer-main">
        <!-- 왼쪽: 로고 + 정보 -->
        <div class="footer-left">
          <div class="footer-logo">
            <router-link to="/">
              <img src="@/assets/logo/logo.png" alt="서희스타힐스 로고" />
            </router-link>
          </div>
          
          <div class="footer-info">
            <div class="info-row">
              <span class="label">현장위치</span>
              <span class="value">충청남도 아산시 모종샛들지구 A-1BL</span>
            </div>
            <div class="info-row">
              <span class="label">광고대행사</span>
              <span class="value">(주)더한걸음</span>
              <span class="divider">|</span>
              <a href="mailto:ad-person@daum.net" class="email">info@dudals.co.kr</a>
            </div>
          </div>
        </div>

        <!-- 오른쪽: 상담문의 -->
        <div class="footer-right">
          <span class="contact-label">상담문의</span>
          <a href="tel:1599-0648" class="contact-number">1599-0648</a>
        </div>
      </div>

      <!-- 주의사항 영역 -->
      <div class="footer-notice">
        <p>※ 본 사이트의 CG, 일러스트, 이미지 등은 소비자의 이해를 돕기 위해 제작된 것으로 실제와 상이할 수 있습니다.</p>
        <p>※ 상기 이미지는 소비자의 이해를 돕기 위해 제작된 것으로 실제와 차이가 있을 수 있습니다.</p>
      </div>
      
      <!-- 하단 카피라이트 -->
      <div class="footer-bottom">
        <p class="copyright">Copyright ⓒ 아산모종 서한이다음 노블리스 All Rights Reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.footer {
  width: 100%;
  background: #1a1a1a;
  color: #999;
  padding: 50px 0 35px;
}

.footer-inner {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
}

/* 메인 영역 */
.footer-main {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
  padding-bottom: 35px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

/* 왼쪽 영역 */
.footer-left {
  flex: 1;
}

.footer-logo {
  margin-bottom: 20px;
}

.footer-logo img {
  height: 32px;
  filter: brightness(0) invert(1);
  opacity: 0.85;
}

/* 정보 영역 - 한 줄 */
.footer-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 13px;
  line-height: 1.6;
}

.info-row .label {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
}

.info-row .value {
  color: rgba(255, 255, 255, 0.45);
}

.info-row .divider {
  color: rgba(255, 255, 255, 0.2);
  margin: 0 6px;
}

.info-row .email {
  color: rgba(255, 255, 255, 0.45);
  text-decoration: none;
  transition: color 0.3s ease;
}

.info-row .email:hover {
  color: #fff;
}

/* 오른쪽: 상담문의 */
.footer-right {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.contact-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 1px;
}

.contact-number {
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  text-decoration: none;
  letter-spacing: 2px;
  transition: color 0.3s ease;
}

.contact-number:hover {
  color: #c9a96e;
}

/* 주의사항 영역 */
.footer-notice {
  padding: 25px 0;
}

.footer-notice p {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.3);
  line-height: 1.9;
  margin: 0;
}

/* 하단 카피라이트 */
.footer-bottom {
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.copyright {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.25);
  letter-spacing: 0.3px;
  margin: 0;
}

/* 반응형 */
@media (max-width: 1024px) {
  .footer {
    padding: 45px 0 30px;
  }

  .footer-inner {
    padding: 0 30px;
  }

  .info-row {
    font-size: 12px;
  }

  .contact-number {
    font-size: 32px;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 40px 0 28px;
  }

  .footer-inner {
    padding: 0 20px;
  }

  .footer-main {
    flex-direction: column;
    gap: 30px;
    align-items: center;
    text-align: center;
  }

  .footer-left {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .footer-logo {
    margin-bottom: 20px;
  }

  .footer-logo img {
    height: 28px;
  }

  .info-row {
    justify-content: center;
    font-size: 11px;
  }

  .info-row .divider {
    display: none;
  }

  .info-row .label::before {
    content: '';
    display: block;
  }

  .footer-right {
    align-items: center;
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    width: 100%;
  }

  .contact-label {
    font-size: 12px;
  }

  .contact-number {
    font-size: 32px;
  }

  .footer-notice {
    padding: 20px 0;
    text-align: left;
  }

  .footer-notice p {
    font-size: 10px;
    line-height: 1.8;
  }

  .footer-bottom {
    text-align: center;
  }

  .copyright {
    font-size: 10px;
  }
}
</style>